import axios from 'axios';

// Isolated client for the System Design stack (sysdesign.app.lxop.in). Pages are
// public, so no 401 redirect — but the JWT is attached when present so future
// member-only features (bookmarks, progress) need no change here.
const BASE_URL =
  (typeof window !== 'undefined' && window.electronEnv?.sysDesignApiUrl) ||
  process.env.REACT_APP_SYSDESIGN_API_URL ||
  'https://sysdesign.app.lxop.in';

const sysDesignApi = axios.create({ baseURL: BASE_URL, timeout: 20000 });
sysDesignApi.interceptors.request.use((config) => {
  const token = localStorage.getItem('lxops_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Open Graph proxy URL — what gets posted to LinkedIn / X so the link renders a
// preview card. It redirects a human straight back into the app.
export const shareUrlFor = (slug) =>
  `${BASE_URL}/share/system-designs/${encodeURIComponent(slug)}`;

// Absolute URL of a design's SVG — handy for "open in new tab" and downloads.
export const diagramUrl = (slug, download = false) =>
  `${BASE_URL}/system-designs/${encodeURIComponent(slug)}/diagram.svg${download ? '?download=1' : ''}`;

// Case studies are served by the same stack under /case-studies.
export const caseStudyShareUrl = (slug) =>
  `${BASE_URL}/share/case-studies/${encodeURIComponent(slug)}`;
export const caseStudyDiagramUrl = (slug, download = false) =>
  `${BASE_URL}/case-studies/${encodeURIComponent(slug)}/diagram.svg${download ? '?download=1' : ''}`;

export default sysDesignApi;
